import { render } from "./AddServiceDetailsDialog.vue?vue&type=template&id=d6ba9a82"
import script from "./AddServiceDetailsDialog.vue?vue&type=script&lang=js"
export * from "./AddServiceDetailsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__